import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CellWrapper, CheckboxRegularWrapper, StyledCheckbox, Hint } from '../styles';

const CheckboxPrimaryCell = ({
  isActive = false,
  isEditing = false,
  rowIndex,
  colIndex,
  registerCellRef,
}) => {
  const [showHint, setShowHint] = useState(false);
  const cellRef = useRef(null);

  useEffect(() => {
    if (registerCellRef && typeof rowIndex === 'number' && typeof colIndex === 'number') {
      registerCellRef(rowIndex, colIndex, cellRef.current);

      return () => registerCellRef(rowIndex, colIndex, null);
    }

    return undefined;
  }, [registerCellRef, rowIndex, colIndex]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
    }
  };

  return (
    <CellWrapper
      ref={cellRef}
      isActive={isActive}
      isEditing={isEditing}
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      <CheckboxRegularWrapper
        onMouseEnter={() => setShowHint(true)}
        onMouseLeave={() => setShowHint(false)}
      >
        <StyledCheckbox
          type="checkbox"
          disabled
        />
        {showHint && (
          <Hint>
            Primary residence cannot be selected, deleted, or moved to another group.
          </Hint>
        )}
      </CheckboxRegularWrapper>
    </CellWrapper>
  );
};

CheckboxPrimaryCell.propTypes = {
  isActive: PropTypes.bool,
  isEditing: PropTypes.bool,
  rowIndex: PropTypes.number,
  colIndex: PropTypes.number,
  registerCellRef: PropTypes.func,
};

CheckboxPrimaryCell.defaultProps = {
  isActive: false,
  isEditing: false,
  rowIndex: undefined,
  colIndex: undefined,
  registerCellRef: undefined,
};

export default CheckboxPrimaryCell;
